import { INameTranslation } from "../../core/model/translations/NameTranslation";
import { IIndexType } from "../../indexTypes/model/IndexType";
import {
  IIndexTypeGroup,
  TIndexTypeGroup
} from "../../indexTypes/model/IndexTypeGroup";
import IndexTypeGroupMapper from "../../indexTypes/service/IndexTypeGroupMapper";
import IndexTypeMapper from "../../indexTypes/service/IndexTypeMapper";
import { IOrganisationIndex } from "../model/OrganisationIndex";
import { IOrganisationIndexGroup } from "../model/OrganisationIndexGroup";
import OrganisationIndexGroupMapper from "./OrganisationIndexGroupMapper";
import OrganisationIndexMapper from "./OrganisationIndexMapper";

export interface TOrganisationIndexTree {
  id: number;
  indexTypeCategoryId: number;
  indexTypeGroupList: IIndexTypeGroup[];
  indexTypeList: IIndexType[];
  name: string;
  organisationId: number;
  organisationIndexGroups: IOrganisationIndexGroup[];
  organisationIndexList: IOrganisationIndex[];
  valid: boolean;
  nameTranslations: INameTranslation[];
}

export interface TOrganisationIndexResponse {
  id: number;
  indexTypeCategoryId: number;
  indexTypeGroupList: any[];
  indexTypeList: any[];
  name: string;
  nameTranslations: INameTranslation[];
  organisationId: number;
  organisationIndexGroups: any[];
  organisationIndexList: any[];
  valid: string;
}

const enrichIndexes = (
  indexTypes: IIndexType[],
  indexList: IOrganisationIndex[]
) => {
  return indexList?.map((item) => {
    item.type = indexTypes.find((type) => type.id === item.indexTypeId);
    return item;
  });
};
const enrichGroups = (
  groupTypes: TIndexTypeGroup[],
  groups: IOrganisationIndexGroup[],
  indexList: IOrganisationIndex[]
) => {
  return groups?.map((group) => {
    group.groupType = groupTypes.find(
      (item) => item.id === group.indexTypeGroupId
    );
    group.addChildren(
      indexList.filter((item) => group.isParent(item.organisationGroupId))
    );
    // group.children = indexList.filter(
    //   (item) => item.organisationGroupId === group.id
    // );
    return group;
  });
};

const collectGroups = (groups: IOrganisationIndexGroup[]) => {
  let _groups: IOrganisationIndexGroup[] = [];
  let foundIds: Set<string> = new Set();
  let _allGroups: {
    [key: string]: {
      ids: string[];
      root: boolean;
      value: IOrganisationIndexGroup;
    };
  } = {};

  groups.forEach((item) => {
    if (item.parentId == null) {
      if (!foundIds.has(item.id.toString())) {
        _groups.push(item);
        let ids = item.groupIds?.split("-") || [item.id.toString()];
        ids?.forEach((id) => {
          foundIds.add(id);
          _allGroups[id] = {
            ids,
            root: true,
            value: item
          };
        });
      }
    } else {
      if (!foundIds.has(item.id.toString())) {
        //let result = _group.find(item.parentId);
        let parent = _allGroups[item.parentId];
        parent?.value?.addGroup(item);

        let ids = item.groupIds?.split("-") || [item.id.toString()];
        ids?.forEach((id) => {
          foundIds.add(id);
          _allGroups[id] = {
            ids,
            root: false,
            value: item
          };
        });
      }
    }
  });
  _groups = Object.values(_allGroups)
    .filter((item) => item.root == true)
    .map((item) => item.value);
  let set = new Set(
    _groups.map((item) => (item.groupIds ? item.groupIds : item.id))
  );
  let _result = [...set]
    .map((item) =>
      _groups.find((group) =>
        group.groupIds ? group.groupIds == item : group.id == item
      )
    )
    .filter((item) => item != undefined) as IOrganisationIndexGroup[];
  return _result || [];
};

const OrganizationIndexTreeMapper = (model: TOrganisationIndexResponse) => {
  let {
    organisationIndexList,
    indexTypeGroupList,
    indexTypeList,
    organisationIndexGroups
  } = model;

  organisationIndexList = organisationIndexList?.map(OrganisationIndexMapper);
  indexTypeGroupList = indexTypeGroupList?.map(IndexTypeGroupMapper);
  indexTypeList = indexTypeList?.map(IndexTypeMapper);
  organisationIndexGroups = organisationIndexGroups?.map(
    OrganisationIndexGroupMapper
  );

  const indexes = enrichIndexes(indexTypeList, organisationIndexList);
  let collectedGroups = enrichGroups(
    indexTypeGroupList,
    organisationIndexGroups,
    indexes
  );
  return collectGroups(collectedGroups);
};

export default OrganizationIndexTreeMapper;
